import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useTellescopeQuery } from "@tellescope/tanstack-query";
import { CONTACT_DETAILS_BLOCKS_FLAT_MAP, isFetchableViewId, resolveBlockRef } from "@tellescope/contact-details";
import { formatName } from "@tellescope/utils";
import { NavTakeoverCard } from "./NavTakeoverCard";
import { useReopenSidebarAction } from "../../pages/contacts/useReopenSidebarAction";

const isKnownBlockType = (type: string): type is keyof typeof CONTACT_DETAILS_BLOCKS_FLAT_MAP =>
  type in CONTACT_DETAILS_BLOCKS_FLAT_MAP;

export const ContactDetailsTakeoverCard = () => {
  const { t } = useTranslation("contacts");
  const { enduserId, viewId, blockId } = useParams();

  const { data: enduser } = useTellescopeQuery({
    model: "endusers",
    method: "getOne",
    request: enduserId ?? "",
    enabled: !!enduserId,
  });

  const { data: block } = useTellescopeQuery({
    model: "custom_dashboards",
    method: "getOne",
    request: viewId ?? "",
    enabled: isFetchableViewId(viewId),
    select: (data) => resolveBlockRef({ blocks: data.blocks, blockId, blockIndex: -1 }).block,
  });

  const blockTypeName =
    block && isKnownBlockType(block.type) ? CONTACT_DETAILS_BLOCKS_FLAT_MAP[block.type].getName() : undefined;
  const blockName = block?.info?.title || blockTypeName;

  const reopenAction = useReopenSidebarAction(enduserId ?? "");

  return (
    <NavTakeoverCard
      title={enduser ? formatName(enduser) : t("Contact")}
      description={t("Now viewing: {{blockName}}", { blockName: blockName ?? t("Block") })}
      onTitleClick={reopenAction?.onClick}
    />
  );
};
